import React from "react";
import Skeleton from "react-loading-skeleton";

const PlaceholderCard = () => {
  return (
    <div className="group-card">
      <div className="group-avatar">{""}</div>
      <h6 className="group-name w-100 text-center">
        <Skeleton width="50%" height="1rem" />
      </h6>
      <div className="group-details w-100 text-center" style={{ display: "block" }}>
        <Skeleton width="90%" height="0.85rem" />
      </div>
    </div>
  );
};

export default PlaceholderCard;
